module.exports = __webpack_public_path__ + "img/shell.538e456f.jpeg";